module.exports = __webpack_public_path__ + "static/img/xueyuanLogo.c8ceefd.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/index/assets/xueyuanLogo.png
// module id = 2U2w
// module chunks = 1